import React, { useState } from 'react';
import { Container, Row, Col, Card, Button, Dropdown } from 'react-bootstrap';
import { TrendingUp, DollarSign, Users, Package, Download, Calendar, Filter, ChevronRight } from 'lucide-react';
import DonorLayout from "../../../layouts/donor/DonorLayout";
import '../../../assets/css/donor/dashboard/Analytics.css';

const Analytics = () => {
  const [dateRange, setDateRange] = useState('all');
  const [reportType, setReportType] = useState('overview');

  // Statistics data
  const stats = {
    totalDonated: 8500,
    goalsReached: 3,
    feeSupport: 37000,
    remitDocuments: 37000,
    walletDonations: 10000
  };

  // Top donors data
  const topDonors = [
    {
      id: 1,
      name: 'Rizam Nohan',
      amount: 10000,
      type: 'Direct',
      avatar: 'RN'
    },
    {
      id: 2,
      name: 'Hassan Rizan',
      amount: 10000,
      type: 'Wallet',
      avatar: 'HR'
    },
    {
      id: 3,
      name: 'Ayaan Ahmed',
      amount: 9500,
      type: 'Direct',
      avatar: 'AA'
    }
  ];

  // Donation breakdown
  // const donationBreakdown = [
  //   { category: 'Fee Support', amount: 37000, percentage: 43.5, color: '#10183f' },
  //   { category: 'Remit Documents', amount: 37000, percentage: 43.5, color: '#4a90e2' },
  //   { category: 'Wallet Donations', amount: 10000, percentage: 11.8, color: '#7ed321' },
  //   { category: 'Other Support', amount: 1000, percentage: 1.2, color: '#f5a623' }
  // ];

  // Monthly trends data
  const monthlyTrends = [
    { month: 'Jan', donations: 1200, cases: 3 },
    { month: 'Feb', donations: 1800, cases: 5 },
    { month: 'Mar', donations: 2500, cases: 7 },
    { month: 'Apr', donations: 2000, cases: 4 },
    { month: 'May', donations: 1000, cases: 2 }
  ];

  const handleDownloadReport = (type) => {
    console.log('Downloading report:', type);
    // Implementation for report download
  };

  return (
    <DonorLayout>
    <div className="reports-analytics-container">
      <Container fluid>
        {/* Page Header */}
        <Row className="reports-analytics-header">
          <Col>
            <h2 className="reports-analytics-title">Reports & Analytics</h2>
          </Col>
          <Col xs="auto">
            <Button 
              className="reports-analytics-download-btn"
              onClick={() => handleDownloadReport('full')}
            >
              <Download size={18} />
              Download Full Report
            </Button>
          </Col>
        </Row>

        {/* Filters Section */}
        <Row className="reports-analytics-filters">
          <Col md={3}>
            <div className="reports-analytics-filter-box">
              <Calendar size={18} className="reports-analytics-filter-icon" />
              <Dropdown className="reports-analytics-filter-dropdown">
                <Dropdown.Toggle variant="light" className="reports-analytics-filter-toggle">
                  {dateRange === 'all' ? 'Goals Period all' : dateRange}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item onClick={() => setDateRange('all')}>All Time</Dropdown.Item>
                  <Dropdown.Item onClick={() => setDateRange('This Month')}>This Month</Dropdown.Item>
                  <Dropdown.Item onClick={() => setDateRange('Last 3 Months')}>Last 3 Months</Dropdown.Item>
                  <Dropdown.Item onClick={() => setDateRange('This Year')}>This Year</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </Col>
          <Col md={3}>
            <div className="reports-analytics-filter-box">
              <Filter size={18} className="reports-analytics-filter-icon" />
              <Dropdown className="reports-analytics-filter-dropdown">
                <Dropdown.Toggle variant="light" className="reports-analytics-filter-toggle">
                  {reportType === 'overview' ? 'Overview' : reportType}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item onClick={() => setReportType('overview')}>Overview</Dropdown.Item>
                  <Dropdown.Item onClick={() => setReportType('donations')}>Donations Only</Dropdown.Item>
                  <Dropdown.Item onClick={() => setReportType('cases')}>Cases Only</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </Col>
        </Row>

        {/* Main Statistics - 100% WIDTH */}
        <Row className="reports-analytics-main-stats">
          <Col xs={6} className="d-flex">
            <Card className="reports-analytics-main-card w-100">
              <Card.Body>
                <h3 className="reports-analytics-card-title">Total Donated</h3>
                <h2 className="reports-analytics-main-amount">PKR {stats.totalDonated.toLocaleString()}</h2>
                <Row>
                {/* <Row className="mt-4 g-3"> */}
                  <Col md={6} className="d-flex">
                    <div className="reports-analytics-stat-item w-100">
                      <div className="reports-analytics-stat-label">
                        <span className="reports-analytics-stat-icon">✓</span>
                        Goals Reach all
                      </div>
                      <div className="reports-analytics-stat-value">{stats.goalsReached}</div>
                    </div>
                  </Col>
                  <Col md={6} className="d-flex">
                    <div className="reports-analytics-stat-item w-100">
                      <div className="reports-analytics-stat-label">
                        <span className="reports-analytics-stat-icon">📄</span>
                        Fee Support
                      </div>
                      <div className="reports-analytics-stat-value">PKR {stats.feeSupport.toLocaleString()}</div>
                    </div>
                  </Col>
                  </Row>
                  <Row>
                  <Col md={6} className="d-flex">
                    <div className="reports-analytics-stat-item w-100">
                      <div className="reports-analytics-stat-label">
                        <span className="reports-analytics-stat-icon">📋</span>
                        Remit Documents
                      </div>
                      <div className="reports-analytics-stat-value">PKR {stats.remitDocuments.toLocaleString()}</div>
                    </div>
                      </Col>  
                      </Row>
                    </Card.Body>
                 </Card>
        
                  </Col>    
                     <Col xs={6} className="d-flex">
            <Card className="reports-analytics-card w-100">
              <Card.Body>
                <div className="reports-analytics-section-header">
                  <h4 className="reports-analytics-section-title">Monthly Donation Trends</h4>
                  <div className="reports-analytics-legend">
                    <span className="reports-analytics-legend-item">
                      <span className="reports-analytics-legend-dot" style={{ backgroundColor: '#10183f' }}></span>
                      Donations
                    </span>
                    <span className="reports-analytics-legend-item">
                      <span className="reports-analytics-legend-dot" style={{ backgroundColor: '#4a90e2' }}></span>
                      Cases Supported
                    </span>
                  </div>
                </div>

                <div className="reports-analytics-chart">
                  <div className="reports-analytics-bar-chart">
                    {monthlyTrends.map((data, index) => (
                      <div key={index} className="reports-analytics-bar-group">
                        <div className="reports-analytics-bars">
                          <div 
                            className="reports-analytics-bar reports-analytics-bar-donations"
                            style={{ height: `${(data.donations / 3000) * 100}%` }}
                            title={`PKR ${data.donations}`}
                          ></div>
                          <div 
                            className="reports-analytics-bar reports-analytics-bar-cases"
                            style={{ height: `${(data.cases / 10) * 100}%` }}
                            title={`${data.cases} cases`}
                          ></div>
                        </div>
                        <span className="reports-analytics-bar-label">{data.month}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>         
           
        </Row>

        {/* Recent Top Donors & Donation Breakdown */}
        {/* <Row className="mt-4 g-4">
          <Col lg={6} className="d-flex">
            <Card className="reports-analytics-card w-100">
              <Card.Body>
                <div className="reports-analytics-section-header">
                  <h4 className="reports-analytics-section-title">Recent Top Donors</h4>
                  <Button variant="link" className="reports-analytics-view-link">
                    View more
                  </Button>
                </div>

                <div className="reports-analytics-donors-list">
                  {topDonors.map((donor, index) => (
                    <div key={donor.id} className="reports-analytics-donor-item">
                      <div className="reports-analytics-donor-rank">#{index + 1}</div>
                      <div className="reports-analytics-donor-avatar">
                        {donor.avatar}
                      </div>
                      <div className="reports-analytics-donor-info">
                        <h5 className="reports-analytics-donor-name">{donor.name}</h5>
                        <span className="reports-analytics-donor-amount">PKR {donor.amount.toLocaleString()}</span>
                      </div>
                      <div className="reports-analytics-donor-type">
                        <span className="reports-analytics-type-badge">{donor.type}</span>
                        <ChevronRight size={16} className="reports-analytics-chevron" />
                      </div>
                    </div>
                  ))}
                </div>

                <div className="reports-analytics-total-row">
                  <span className="reports-analytics-total-label">PKR 102,100</span>
                  <span className="reports-analytics-total-sublabel">Total Amount</span>
                </div>
              </Card.Body>
            </Card>
          </Col>

          {/* Donation Breakdown */}
          {/* <Col lg={6} className="d-flex">
            <Card className="reports-analytics-card w-100">
              <Card.Body>
                <h4 className="reports-analytics-section-title">Donation Breakdown</h4>
                
                <div className="reports-analytics-breakdown-chart">
                  {/* Pie Chart Representation */}
                  {/* <div className="reports-analytics-pie-chart">
                    <div className="reports-analytics-pie-center">
                      <div className="reports-analytics-pie-total">PKR {stats.totalDonated}</div>
                      <div className="reports-analytics-pie-label">Total</div>
                    </div>
                  </div>
                </div> */}

                {/* <div className="reports-analytics-breakdown-list">
                  {donationBreakdown.map((item, index) => (
                    <div key={index} className="reports-analytics-breakdown-item">
                      <div className="reports-analytics-breakdown-info">
                        <span 
                          className="reports-analytics-breakdown-color"
                          style={{ backgroundColor: item.color }}
                        ></span>
                        <span className="reports-analytics-breakdown-category">{item.category}</span>
                      </div>
                      <div className="reports-analytics-breakdown-values">
                        <span className="reports-analytics-breakdown-amount">PKR {item.amount.toLocaleString()}</span>
                        <span className="reports-analytics-breakdown-percentage">{item.percentage}%</span>
                      </div>
                    </div>
                  ))}
                </div>
              </Card.Body>
            </Card> */}
          {/* </Col>  */}
        {/* </Row>  */}

        {/* Monthly Trends - 100% WIDTH */}
        {/* <Row className="mt-4">
          {/* <Col xs={6} className="d-flex">
            <Card className="reports-analytics-card w-100">
              <Card.Body>
                <div className="reports-analytics-section-header">
                  <h4 className="reports-analytics-section-title">Monthly Donation Trends</h4>
                  <div className="reports-analytics-legend">
                    <span className="reports-analytics-legend-item">
                      <span className="reports-analytics-legend-dot" style={{ backgroundColor: '#10183f' }}></span>
                      Donations
                    </span>
                    <span className="reports-analytics-legend-item">
                      <span className="reports-analytics-legend-dot" style={{ backgroundColor: '#4a90e2' }}></span>
                      Cases Supported
                    </span>
                  </div>
                </div>

                <div className="reports-analytics-chart">
                  <div className="reports-analytics-bar-chart">
                    {monthlyTrends.map((data, index) => (
                      <div key={index} className="reports-analytics-bar-group">
                        <div className="reports-analytics-bars">
                          <div 
                            className="reports-analytics-bar reports-analytics-bar-donations"
                            style={{ height: `${(data.donations / 3000) * 100}%` }}
                            title={`PKR ${data.donations}`}
                          ></div>
                          <div 
                            className="reports-analytics-bar reports-analytics-bar-cases"
                            style={{ height: `${(data.cases / 10) * 100}%` }}
                            title={`${data.cases} cases`}
                          ></div>
                        </div>
                        <span className="reports-analytics-bar-label">{data.month}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>  */}
        {/* </Row>  */}

        {/* Quick Reports
        <Row className="mt-4">
          <Col>
            <h4 className="reports-analytics-section-title mb-3">Quick Export Reports</h4>
          </Col>
        </Row>

        <Row className="g-3">
          <Col md={3} className="d-flex">
            <Card className="reports-analytics-export-card w-100">
              <Card.Body>
                <div className="reports-analytics-export-icon">
                  <DollarSign size={28} />
                </div>
                <h5 className="reports-analytics-export-title">Donation Summary</h5>
                <p className="reports-analytics-export-description">Complete donation history with details</p>
                <Button 
                  variant="outline-primary" 
                  size="sm"
                  className="reports-analytics-export-btn"
                  onClick={() => handleDownloadReport('donations')}
                >
                  <Download size={14} />
                  Export PDF
                </Button>
              </Card.Body>
            </Card>
          </Col>

          <Col md={3} className="d-flex">
            <Card className="reports-analytics-export-card w-100">
              <Card.Body>
                <div className="reports-analytics-export-icon">
                  <Package size={28} />
                </div>
                <h5 className="reports-analytics-export-title">Cases Report</h5>
                <p className="reports-analytics-export-description">All supported cases breakdown</p>
                <Button 
                  variant="outline-primary" 
                  size="sm"
                  className="reports-analytics-export-btn"
                  onClick={() => handleDownloadReport('cases')}
                >
                  <Download size={14} />
                  Export PDF
                </Button>
              </Card.Body>
            </Card>
          </Col>

          <Col md={3} className="d-flex">
            <Card className="reports-analytics-export-card w-100">
              <Card.Body>
                <div className="reports-analytics-export-icon">
                  <TrendingUp size={28} />
                </div>
                <h5 className="reports-analytics-export-title">Impact Analysis</h5>
                <p className="reports-analytics-export-description">Your donation impact metrics</p>
                <Button 
                  variant="outline-primary" 
                  size="sm"
                  className="reports-analytics-export-btn"
                  onClick={() => handleDownloadReport('impact')}
                >
                  <Download size={14} />
                  Export PDF
                </Button>
              </Card.Body>
            </Card>
          </Col>

          <Col md={3} className="d-flex">
            <Card className="reports-analytics-export-card w-100">
              <Card.Body>
                <div className="reports-analytics-export-icon">
                  <Users size={28} />
                </div>
                <h5 className="reports-analytics-export-title">Tax Certificate</h5>
                <p className="reports-analytics-export-description">Annual tax benefit certificate</p>
                <Button 
                  variant="outline-primary" 
                  size="sm"
                  className="reports-analytics-export-btn"
                  onClick={() => handleDownloadReport('tax')}
                >
                  <Download size={14} />
                  Export PDF
                </Button>
              </Card.Body>
            </Card>
          </Col>
        </Row> */}
      </Container>
    </div>
    </DonorLayout>
  );
};

export default Analytics;